export default __webpack_public_path__ + "static/media/screenshot2.2f1d77ca.png";